<template>
  <label
    :for="id"
    :class="{
      'size-s': size === 's',
      'size-m': size === 'm',
      active: value,
      disabled: disabled
    }"
    @click="!disabled ? $emit('change', !value) : null"
  >
    <span></span>
  </label>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { uuid } from 'vue-uuid'

@Component({
  model: { prop: 'value', event: 'change' }
})
export default class NToggle extends Vue {
  @Prop({ type: Boolean }) value!: boolean
  @Prop({
    type: String,
    validator: (prop: string) => ['s', 'm'].includes(prop),
    default: 'm'
  })
  size!: 's' | 'm'
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  id = uuid.v4()
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

label {
  cursor: pointer;

  display: flex;
  align-items: center;
  position: relative;

  border: 2px solid;
  border-radius: $notch-radius-10x;

  background-color: $notch-color-neutral-sand-400;
  border-color: $notch-color-neutral-sand-400;

  &.active {
    background-color: $notch-color-neutral-grey-900;
    border-color: $notch-color-neutral-grey-900;

    span {
      left: 50%;
    }
  }

  // The `disabled` class was applied but never styled, so a disabled toggle was
  // indistinguishable from a live one and still showed a pointer cursor while its click handler
  // was a no-op.
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  span {
    display: block;
    border: 0 solid transparent;
    border-radius: $notch-radius-full;
    background-color: $notch-color-neutral-grey-000;

    position: absolute;
    left: $notch-space-05x;
    transition: left 300ms;
  }

  input {
    display: none;
  }
}

.size-s {
  width: $notch-space-10x; // 2.5rem
  height: $notch-space-4x;
  span {
    width: $notch-space-3x;
    height: $notch-space-3x;
  }
}

.size-m {
  width: $notch-space-10x;
  height: $notch-space-6x;
  span {
    width: $notch-space-4x;
    height: $notch-space-4x;
  }
}
</style>
